module.exports = __webpack_public_path__ + "static/media/edit_card_title.ebe523fb.gif";